/**
 * 预加载重归白金礼首页与弹窗用到的图片
 * @returns {Promise} 所有图片加载完成的 Promise
 */
export function preloadAllImages() {
  const imageList = [
    require("@/assets/imgs/xibReturnGift/bg_page.png"),
    require("@/assets/imgs/xibReturnGift/prize_panel_bg.png"),
    require("@/assets/imgs/xibReturnGift/gift_rice.png"),
    require("@/assets/imgs/xibReturnGift/gift_thermos.png"),
    require("@/assets/imgs/xibReturnGift/gift_pantene.png"),
    require("@/assets/imgs/xibReturnGift/received.png"),
    require("@/assets/imgs/xibReturnGift/btn_claim_bg.png"),
    require("@/assets/imgs/xibReturnGift/result_bg.png"),
    require("@/assets/imgs/xibReturnGift/rule_close.png"),
    require("@/assets/imgs/xibReturnGift/jimeng_grey.png"),
  ];

  const promises = imageList.map((src) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(src);
      img.onerror = () => resolve(src);
      img.src = src;
    });
  });

  return Promise.all(promises);
}
